import { NonFunctionalPreviewField } from "./NonFunctionPreview";
import { interactiveClientSelector } from "../../store/selectors/clientSettings";
import { useSelector } from 'react-redux';
export const PaymentPreview = ({
  type,
  value,
  rowGuid,
  dependent_entry,
  ...entry
}) => {
  // TODO: replace this with lib/field validations
  const interactiveClient = useSelector(interactiveClientSelector);
  const hasError = interactiveClient && !dependent_entry;
  return <NonFunctionalPreviewField {...entry} type={type} value={value} rowGuid={rowGuid} disabled={!dependent_entry} dependent_entry={dependent_entry} errorText="To use a Payment field, you must first add a Number (with decimal or currency style) or Calculation field to your app." hasError={hasError} />;
};